import * as _ from 'lodash';

export enum ApprovalStatus {
  COMPLETED = 'Completed',
  PENDING = 'Pending'
}
export enum CommonPunchTypes {
  ndb1Out = 'ndb1Out',
  ndb1In = 'ndb1In',
  meal1Out = 'meal1Out',
  meal1In = 'meal1In',
  meal2Out = 'meal2Out',
  meal2In = 'meal2In',
}
export enum CrewPunchTypes {
  call = 'call',
  ndb2Out = 'ndb2Out',
  ndb2In = 'ndb2In',
  wrap = 'wrap',
  last = 'last'
}
export enum SagPunchTypes {
  makeupWardrobeIn = 'makeupWardrobeIn',
  onSet = 'onSet',
  dismiss = 'dismiss',
  makeupWardrobeOut = 'makeupWardrobeOut',
  leaveForLocation = 'leaveForLocation',
  arriveOnLocation = 'arriveOnLocation',
  leaveLocation = 'leaveLocation',
  arriveStudio = 'arriveStudio',
}
/**
 *   For Manage Unit Screen and UK Timecard Punches, we need new Punch Types handle Time In/Out, ScheduledWrap and Travel In/Out.
 *   TimeIn/Out - to be consistent with our existing approach, crew uses Call/Wrap, SAG uses onSet/Dismiss, then UK will use Time In/Out for call/wrap.
 *     5 v44** Note that we will reuse Time In/Out in Manage Unit as Unit Call and Actual Wrap **
 *   Meals punch types are reused from CommonPunchTypes, e.g.
 *   meal1Out =  M1 Start
 *   meal1In =  M1 End
 *   meal2Out = M2 Start
 *   meal2In = M2 End
 *   wrap = "Wrap" and "Actual Wrap in Project Unit punches"
 * */
export enum UkPunchTypes {
  call = 'call',
  meal1Start = 'meal1Start',
  meal1End = 'meal1End',
  meal2Start = 'meal2Start',
  meal2End = 'meal2End',
  wrap = 'wrap', // Actual Wrap in Unit page
}

export enum UkIntervalPunchTypes {
  travelIn = 'travelIn',
  travelOut = 'travelOut',
}

export enum UkPunchTypesForUnit {
  scheduledWrap = 'scheduledWrap',
  unitCall = 'unitCall',
  unitWrap = 'unitWrap'
}

export const UkUnitPunchTypes = {...UkPunchTypes, ...UkPunchTypesForUnit};
/**
 * In UK Punches, it support Intervals, in Minutes.
 * Because Regular UK Punch types like Call and Wrap is using the Full Date String, we cannot put Travel In/Out as punches because those uses Number of Minutes
 * so, a number type and not a Full Date String.
 * */
export enum UkPunchIntervalTypes {
  travelIn = 'travelIn',
  travelOut = 'travelOut'
}

export const UkAllUnitPunchTypes = {...UkUnitPunchTypes, ...UkPunchIntervalTypes};

export enum ErrorType {
  SUBMITTABLE = 'SUBMITTABLE',
  NOT_SUBMITTABLE = 'NOT_SUBMITTABLE',
  AMOUNT_MISMATCH = 'AMOUNT_MISMATCH',
  DISCREPANCY = 'DISCREPANCY', // This is for UI only and won't get serialized to API
  HARD_ERROR = 'HARD_ERROR', // This is for UI only and won't get serialized to API
  SOFT_ERROR = 'SOFT_ERROR' // This is for UI only and won't get serialized to API
}
export enum ForceCallEnum {
  No = 'NO',
  Yes = 'YES',
  Reduced = 'REDUCED'
}
export enum InternalUserRole {
  PAY_MASTER = 'PAYMASTER',
  PAY_MASTER_MANAGER = 'PAYMASTERMANAGER',
  PROJECT_SETUP = 'PROJECTSETUP',
  PROJECT_SETUP_MANAGER = 'PROJECTSETUPMANAGER',
  SUPPORT = 'SUPPORT'
}
export enum MealPenaltyEnum {
  No = 'NO',
  Yes = 'YES',
  Grace = 'GRACE',
  ThirtyMinWrapExt = 'THIRTY_MIN_WRAP_EXT'
}

export enum ShootCrew {
  No = 'NO',
  Yes = 'YES'
}
export enum MobileApprovalStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export enum SplitType {
  byHour = 'Hour',
  byPercentage = 'Percentage'
}
export enum TimecardErrorMessages {
  BreakageOverride = 'This timecard contains overrides to the original breakage.',
  VisaExpirationSubmittable = 'Timecard Warning - Check Visa expiration date before submitting Timecard',
  VisaExpirationUnsubmittable = 'Timecard Error - Visa expiration date has passed, please contact your Paymaster'
}
export enum TimecardStatus {
  O = 1,
  S = 2,
  D = 3
}
export enum TimecardStatusFilter {
  OPEN = 'O',
  SUBMITTED = 'S'
}
export enum TimecardTypes {
  CREW = 'CREW',
  SAG = 'SAG'
}
export enum WorkConditionEnum {
  Studio = 'Studio',
  Distant = 'Distant',
  Bus_To_Nearby = 'Bus To',
  Report_To = 'Report To',
  Overnight = 'Overnight'
}
export enum WorkflowApprovalStatus {
  NEW = 'NEW',
  ROUTED = 'ROUTED',
  DECLINED = 'DECLINED',
  REROUTED = 'REROUTED',
  RESET = 'RESET',
  APPROVED = 'APPROVED'
}

export function ErrorTypeFromString(errorTypeString: string): ErrorType {
  switch (_.toUpper(errorTypeString)) {
    case 'SUBMITTABLE':
      return ErrorType.SUBMITTABLE;
    case 'NOT_SUBMITTABLE':
      return ErrorType.NOT_SUBMITTABLE;
    case 'AMOUNT_MISMATCH':
      return ErrorType.AMOUNT_MISMATCH;
    default:
      console.log(`[ErrorTypeFromString] Unsupported Type: ${errorTypeString}`);
      return ErrorType.NOT_SUBMITTABLE;
  }
}
// This is the PunchTypes 'enum' that includes all different types of PunchTypes. We use these enums as keys in IPunch interface
export const PunchTypes = {...CommonPunchTypes, ...SagPunchTypes, ...CrewPunchTypes, ...UkPunchTypes, ...UkIntervalPunchTypes, ...UkPunchTypesForUnit};
// This is list of normal date time punch types that is of type string. Exclude UkIntervalPunchTypes
export const DateTimePunchType = {...CommonPunchTypes, ...SagPunchTypes, ...CrewPunchTypes, ...UkPunchTypes, ...UkPunchTypesForUnit};
// This is list of interval punch types that is of type number (Intervals are stored as minutes in database). Only UkIntervalPunchTypes for now.
export const IntervalPunchTypes = {...UkIntervalPunchTypes};
export type IPunchTypes = keyof typeof PunchTypes;
